var map = {
	"./fifa22/ranks/rank_1.png": 846,
	"./fifa22/ranks/rank_10.png": 847,
	"./fifa22/ranks/rank_11.png": 848,
	"./fifa22/ranks/rank_2.png": 849,
	"./fifa22/ranks/rank_3.png": 850,
	"./fifa22/ranks/rank_4.png": 851,
	"./fifa22/ranks/rank_5.png": 852,
	"./fifa22/ranks/rank_6.png": 853,
	"./fifa22/ranks/rank_7.png": 854,
	"./fifa22/ranks/rank_8.png": 855,
	"./fifa22/ranks/rank_9.png": 856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 386;